export default {
  name: 'ExpectedOrderCount',
  props: {
    statistics: {
      required: true,
      type: Object,
    },
  },
  computed: {
    infos() {
      return [
        {
          classes: 'text-black',
          title: '人員總數',
          value: this.statistics.total || 0,
        },
        {
          classes: 'text-primary-500',
          title: '可訂購人員',
          value: this.statistics.joined || 0,
        },
      ];
    },
  },
};
